import React, { useState, useEffect, useRef } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import moment from "moment";
import {
  Row,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Button,
  Input,
  ModalFooter,
} from "reactstrap";
import styled from 'styled-components';

// ASSETS
import CloseIcon from "../../images/close-button-search.png";
import RemoveInput from "../../images/removeinputvalue.png";
import RightArrowGrey from "../../images/right-arrow-grey.png";
import RightArrowWhite from "../../images/right-arrow-white.png";
import TukTuk from "../../images/truck-tuk-tuk.png";
import EmptyVoucher from "../../images/empty_voucher.png";
import CloseButton from "../../images/close30.png"
import DefaultThumbnailRebrand from "../../images/voucher/thumbnail.png";
import DefaultBannerRebrand from "../../images/voucher/banner.png";

// ACTION
import { getUserVoucher } from "../../actions/kickPointAction";
import { doPostApplyVoucher } from "../../actions/paymentAction";
import { getHistoryShipping } from "../../actions/postalCodeAction";

//UTILS
import { formatCurrency, getCloudImageUrl, formatNumber, formatRupiah } from "../../utils";

// const DEFAULT_THUMBNAIL_VOUCHER = "https://kickavenue-assets.s3.amazonaws.com/assets-image/default_voucher.jpg";
// const DEFAULT_BANNER_VOUCHER = "https://kickavenue-assets.s3.amazonaws.com/assets-image/default_voucher_banner.jpg";

function ModalVoucherCode(props) {
  // LOCAL STATE
  const [openDetails, setOpenDetails] = useState(false);
  const [detailVoucher, setDetailVoucher] = useState({});
  const [inputCodeValue, setInputCodeValue] = useState("");
  const [copySuccess, setCopySuccess] = useState("Copy");
  const [selectedVoucherBorder, setSelectedVoucherBorder] = useState(null);
  const [
    showMessageAfterCheckVoucher,
    setShowMessageAfterCheckVoucher,
  ] = useState(false);
  const [inputValueEdited, setInputValueEdited] = useState(false);

  const [applyVoucherResult, setApplyVoucherResult] = useState(null);
  const [applyVoucherResultError, setApplyVoucherResultError] = useState(null);
  const [selectedVoucherId, setSelectedVoucherId] = useState(null);
  const [useNowVouhcer, setUseNowVoucher] = useState(null);
  const [isChangedVoucher, setIsChangedVoucher] = useState(false)

  // USE EFFECT
  useEffect(() => {
    props.isOpen && props.getUserVoucher({ page: 1, per_page: 100 });
    if (props.dataPayments.voucher.error === applyVoucherResultError) setApplyVoucherResultError(null);
    if (props.dataPayments.voucher.error) setInputCodeValue("");
    props.isOpen && setIsChangedVoucher(false)
    props.isOpen && props.selectedVoucherCode && setSelectedVoucherBorder(props.selectedVoucherCode.id)
  }, [props.isOpen]);

  useEffect(() => {
    if (prevInputCodeValue !== inputCodeValue) {
      setShowMessageAfterCheckVoucher(false);
      setInputValueEdited(false);
    }
  }, [inputCodeValue]);

  useEffect(() => {
    setApplyVoucherResult(props.dataPayments.voucher.data);
    setApplyVoucherResultError(props.dataPayments.voucher.error)
  }, [props.dataPayments.voucher]);

  useEffect(() => {
    setApplyVoucherResult(
      props.selectedVoucherCode ? props.dataPayments.voucher.data : null
    );
  }, []);
  const prevInputCodeValueRef = useRef();

  useEffect(() => {
    prevInputCodeValueRef.current = inputCodeValue;
  });
  const prevInputCodeValue = prevInputCodeValueRef.current;

  // FUNCTIONS
  const handleVoucherInputValue = (e) => {
    setInputCodeValue(e.target.value);
  };

  const handleOnToggle = (useNow) => {
    if (!props.selectedVoucherCode && !useNow) {
      setInputCodeValue("");
      setApplyVoucherResultError(null);
      setApplyVoucherResult(null);
      props.handleSelectedVoucherCode(null);
      setSelectedVoucherBorder(null)
    }
    setOpenDetails(false)
    props.onToggle();
    setCopySuccess("Copy");
  };

  const handleApplyVoucher = (VoucherCode) => {
    props.getHistoryShipping();
    const { id, total_subsidy, asking_price } = props.dataCart.user_sell;
    setShowMessageAfterCheckVoucher(true);
    setInputValueEdited(true);
    props.applyVoucher({
      code: VoucherCode,
      user_sell_id: id,
      total_amount: parseFloat(total_subsidy ? total_subsidy : asking_price),
    });
  };

  const handleApplyVoucherFromDetails = (VoucherCode, useNowVouhcer) => {
    props.getHistoryShipping();
    const { id, total_subsidy, asking_price } = props.dataCart.user_sell;
    setShowMessageAfterCheckVoucher(true);
    setInputValueEdited(true);
    props.applyVoucher({
      code: VoucherCode,
      user_sell_id: id,
      total_amount: parseFloat(total_subsidy ? total_subsidy : asking_price),
    }).then(({ value }) => {
      setInputValueEdited(true);
      setSelectedVoucherBorder(useNowVouhcer.id);
      setOpenDetails(false);
      setCopySuccess("Copy");
      props.handleSelectedVoucherCode(
        { ...value?.data }
      );
    })
  };

  const useImageVoucher = (type, images) => {
    let img = "";

    images.forEach((e) => {
      e.orientation == type && (img = e.URL);
    });
    return img;
  };

  const printError = (e) => {
    let errorMessage = "";

    if (!e) return;

    if (!e.errors) {
      if (e.error && e.error.message) errorMessage = e.error.message;
      else errorMessage = e.message;
    } else {
      let { errors } = e;

      for (let idx in errors) {
        let message = errors[idx];

        if (message instanceof Array) {
          message.map((m) => {
            if (m instanceof Object) errorMessage += m.message + "\n";
            else errorMessage += m + "\n";
          });
        } else {
          errorMessage += message + "\n";
        }
      }
    }

    if (errorMessage.includes("Not found"))
      errorMessage = "This voucher code is invalid or has expired.";

    return errorMessage;
  }

  const voucherInfo = () => {

    const potentially_cashback = props.dataPayments && props.dataPayments.voucher && props.dataPayments.voucher.data ? props.dataPayments.voucher.data.potentially_cashback : false

    const is_cashback = props.dataPayments && props.dataPayments.voucher && props.dataPayments.voucher.data ? props.dataPayments.voucher.data.is_cashback : false

    const type = props.dataPayments && props.dataPayments.voucher && props.dataPayments.voucher.data ? props.dataPayments.voucher.data.type : false

    if (is_cashback && potentially_cashback) {
      return (
        <div className="footer-info-voucher">
          <p>
            Up to {type === "percentage" ? `${formatNumber(potentially_cashback)}%` : formatCurrency(potentially_cashback)} Cashback
          </p>
        </div>
      )
    } else {
      return (
        <div className="footer-info-voucher">
          <p>You save</p>
          <p>
            {formatCurrency(props.discount)}
          </p>
        </div>
      )
    }
  }

  return (
    <>
      <Modal
        isOpen={props.isOpen}
        toggle={handleOnToggle}
        className="voucher-code-wrapper"
      >
        <KickImage onClick={handleOnToggle} className="voucher-close-btn" src={CloseButton} alt="..." />
        {!openDetails ? (
          <>
            <div toggle={props.onToggle} className="voucher-code-modal-header">
              <div className="header-content-wrapper">
                <p>VOUCHER</p>
                <div className="close-icon-container" onClick={() => handleOnToggle(true)}>
                  <KickImage src={CloseIcon} alt="close-icon" />
                </div>
              </div>
            </div>
            <ModalBody className="voucher-modal-body">
              <div className="manual-input">
                <div className="manual-input-content">
                  <p>Have a voucher code?</p>
                  <div className="input-voucher-code">
                    <div className="input-field-wrapper">
                      <Input
                        placeholder="Enter voucher code here"
                        className="input-field-rs"
                        value={inputCodeValue}
                        onChange={handleVoucherInputValue}
                      />
                      {inputCodeValue && (
                        <div
                          className="remove-icon"
                          onClick={(e) => {
                            setInputCodeValue("");
                            setApplyVoucherResultError(null);
                            setApplyVoucherResult(null);
                            props.handleSelectedVoucherCode(null);
                            props._handleClearVoucher(e);
                          }}
                        >
                          <KickImage src={RemoveInput} alt="remove-icon" />
                        </div>
                      )}
                    </div>
                    {inputCodeValue === "" ? (
                      <div className="arrow-wrapper">
                        {/* <KickImage src={RightArrowGrey} alt="submit-arrow" /> */}
                        <p>Check</p>
                      </div>
                    ) : (
                      <div
                        className="arrow-wrapper arrow-wrapper-active"
                        onClick={() => {
                          // handleApplyVoucher
                          setInputValueEdited(true);
                          setInputCodeValue(inputCodeValue);
                          setSelectedVoucherBorder(selectedVoucherBorder);
                          handleApplyVoucher(inputCodeValue);
                          props.handleSelectedVoucherCode(null);
                        }}
                      >
                        {/* <KickImage src={RightArrowWhite} alt="submit-arrow" /> */}
                        <p>Check</p>
                      </div>
                    )}
                  </div>
                  {/* {!props.dataPayments.voucher.isSubmit &&
                    showMessageAfterCheckVoucher &&
                    displayCheckMessage()} */}
                </div>
              </div>
              <div className="voucher-list-container">
                <div className="voucher-list-content">
                  <p className="voucher-list-title">My voucher</p>
                  <div className="voucher-list-scroll">
                    {props.dataVoucher.data.length > 0
                      ? props.dataVoucher.data.map((item) => {
                        return (
                          <div
                            key={item.id}
                            className={`voucher-list ${selectedVoucherBorder &&
                              selectedVoucherBorder === item?.voucher?.id
                              ? applyVoucherResultError
                                ? "voucher-list-border-error"
                                : "voucher-list-border"
                              : ""
                              }`}
                          >
                            <div
                              className="top-content"
                              onClick={() => {
                                setOpenDetails(true);
                                setDetailVoucher(item);
                                setSelectedVoucherId(item.id);
                              }}
                            >
                              <div className="tuk-tuk-wrapper">
                                {item.voucher.images.length > 0 ? (
                                  <KickImage
                                    src={getCloudImageUrl(useImageVoucher(
                                      "portrait",
                                      item.voucher.images
                                    ), 200)}
                                    alt="..."
                                  />
                                ) : (
                                  <KickImage src={DefaultThumbnailRebrand} alt="..." />
                                )}
                              </div>
                              <div className="top-content-info">
                                <p>{item.voucher.name}</p>
                                <p>
                                  Min purchase {formatCurrency(item.voucher.minimum_purchase)}
                                </p>
                                <p>
                                    Valid until{" "}
                                    {item?.voucher?.ended_at
                                      ? moment(item?.voucher?.ended_at).format("MMM D, YYYY")
                                      : item?.ended_at? moment(item?.ended_at).format("MMM D, YYYY") : "forever"}
                                </p>
                              </div>
                            </div>
                            <div className="bottom-content">
                              <p>
                                Voucher Code:{" "}
                                <span className="bottom-content-voucher">
                                  {item.voucher.code}
                                </span>
                              </p>
                              <p
                                onClick={() => {
                                  setInputValueEdited(true);
                                  setInputCodeValue(item.voucher.code);
                                  setSelectedVoucherBorder(item.id);
                                  handleApplyVoucher(item.voucher.code);
                                  setUseNowVoucher(item?.voucher)
                                  props.handleSelectedVoucherCode(null);
                                  setIsChangedVoucher(true)
                                }}
                              >
                                <i>Use Now</i>
                              </p>
                            </div>
                          </div>
                        );
                      })
                      :
                      <EmptyWrapper>
                        <KickImage src={EmptyVoucher} />
                        <p>You can find an ongoing promotions at our instagram @kick.avenue or by regularly shopping at Kick Avenue.</p>
                      </EmptyWrapper>
                    }
                  </div>
                </div>
              </div>
            </ModalBody>

            {!props.dataPayments.voucher.isSubmit &&
              applyVoucherResult &&
              !applyVoucherResultError && (
                <ModalFooter className="voucher-modal-footer-wrapper">
                  <div className="voucher-footer-modal">
                    {voucherInfo()}
                    {(!props.selectedVoucherCode || isChangedVoucher) ? (
                      <div
                        className="footer-button"
                        onClick={() => {
                          props.handleSelectedVoucherCode(
                            { ...props.dataPayments.voucher.data, useNowVouhcer }
                          );
                          handleOnToggle(true);
                          setInputCodeValue(props.dataPayments.voucher.data.code);
                        }}
                      >
                        Use voucher
                      </div>
                    ) : (
                      <div
                        className="footer-button"
                        onClick={(e) => {
                          setInputCodeValue("");
                          setApplyVoucherResultError(null);
                          setApplyVoucherResult(null);
                          props.handleSelectedVoucherCode(null);
                          props._handleClearVoucher(e);
                        }}
                        style={{ background: "#d14242" }}
                      >
                        Remove
                      </div>
                    )}
                  </div>
                </ModalFooter>
              )}
            {!props.dataPayments.voucher.isSubmit && applyVoucherResultError && (
              <ModalFooter className="voucher-modal-footer-wrapper voucher-modal-footer-error-message-wrapper">
                <div className="voucher-footer-modal">
                  <div className="footer-info-voucher">
                    <p>{printError(applyVoucherResultError)}</p>
                  </div>
                  <div
                    className="footer-button"
                    onClick={() => {
                      setInputCodeValue("");
                      setApplyVoucherResultError(null);
                      setApplyVoucherResult(null);
                      props.handleSelectedVoucherCode(null);
                    }}
                  >
                    Remove
                  </div>
                </div>
              </ModalFooter>
            )}
          </>
        ) : (
          <>
            <div className="voucher-code-modal-header">
              <div className="header-content-wrapper">
                <p
                  onClick={() =>
                    console.log(applyVoucherResult, "applyVoucherResult")
                  }
                >
                  VOUCHER DETAIL
                </p>
                <div
                  className="close-icon-container"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setOpenDetails(false);
                    setCopySuccess("Copy");
                  }}
                >
                  <KickImage src={CloseIcon} alt="close-icon" />
                </div>
              </div>
            </div>
            <ModalBody className="voucher-code-details-wrapper">
              <div className="header-details">
                <div className="tuk-tuk-wrapper">
                  {detailVoucher?.voucher?.images.length > 0 ? (
                    <KickImage
                      src={getCloudImageUrl(useImageVoucher("landscape", detailVoucher?.voucher?.images), 900)}
                      alt="..."
                      className="truck-icon"
                    />
                  ) : (
                    <KickImage src={DefaultBannerRebrand} alt="..." className="truck-icon" />
                  )}
                </div>
              </div>
              <div className="voucher-info-container">
                <div className="voucher-info-wrapper">
                  <p className="voucher-info-title">{detailVoucher?.voucher?.name}</p>
                  <div className="voucher-info-date">
                    <div className="first-info">
                      <p>Minimum purchase</p>
                      <p>
                        {formatCurrency(detailVoucher?.voucher?.minimum_purchase)}
                      </p>
                    </div>
                    <div className="second-info">
                      <p>Valid until</p>
                      <p>
                        {detailVoucher?.voucher?.ended_at
                          ? moment(detailVoucher?.voucher?.ended_at).format("MMM D, YYYY")
                          : detailVoucher?.ended_at? moment(detailVoucher?.ended_at).format("MMM D, YYYY") : "forever"}
                      </p>
                    </div>
                  </div>
                  <div className="info-field-wrapper">
                    <p>
                      Voucher code: <span>{detailVoucher?.voucher?.code}</span>
                    </p>
                    <p
                      onClick={() => {
                        navigator.clipboard.writeText(detailVoucher?.voucher?.code);
                        setCopySuccess("Copied");
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {copySuccess}
                    </p>
                  </div>
                </div>
              </div>
              {detailVoucher?.voucher?.description && detailVoucher?.voucher?.terms && <div className="voucher-description-term-condition-outside-wrapper">
                <div className="voucher-description-term-condition-inside-wrapper">
                  {true && <div className="voucher-description-wrapper">
                    <p>Description</p>
                    <p
                      dangerouslySetInnerHTML={{
                        __html: detailVoucher?.voucher?.description,
                      }}
                    />
                  </div>}
                  {true && <div className="voucher-term-condition-wrapper">
                    <p>Terms and Condition</p>
                    <div className="list-term-condition-wrapper">
                      <ol
                        dangerouslySetInnerHTML={{
                          __html: detailVoucher?.voucher?.terms,
                        }}
                      />
                    </div>
                  </div>}
                </div>
              </div>}
              {selectedVoucherBorder !== selectedVoucherId ? (
                <div
                  className="voucher-detail-use-now-button-wrapper"
                  onClick={(e) => {
                    handleOnToggle(true);
                    handleApplyVoucherFromDetails(detailVoucher?.voucher?.code, detailVoucher?.voucher)
                  }}
                >
                  <div className="voucher-detail-use-now-button">
                    <p>Use Now</p>
                  </div>
                </div>
              ) : (
                <div
                  className="voucher-detail-use-now-button-wrapper"
                  onClick={(e) => {
                    setInputValueEdited(false);
                    setSelectedVoucherBorder(null);
                    setOpenDetails(false);
                    setCopySuccess("Copy");
                    setInputCodeValue("");
                    setApplyVoucherResultError(null);
                    setApplyVoucherResult(null);
                    props._handleClearVoucher(e);
                    props.handleSelectedVoucherCode(null);
                  }}
                >
                  <div
                    className="voucher-detail-use-now-button"
                    style={{ backgroundColor: "#d14242" }}
                  >
                    <p>Remove</p>
                  </div>
                </div>
              )}
            </ModalBody>
          </>
        )}
      </Modal>
    </>
  );
}

const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 150px;
    margin-bottom: 2rem;
  }
  p {
    font-size: 12px;
    font-family: 'DMSans-Regular';
    text-align: center;
    color: #242424;
    line-height: 18px;
  }
`

const mapStateToProps = (state) => {
  return {
    dataVoucher: state.dataKickPoint.userVoucher,
    dataPayments: state.dataPayment,
    dataCart: state.dataProduct.cart,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getUserVoucher: (payload) => dispatch(getUserVoucher(payload)),
  applyVoucher: (payload) => dispatch(doPostApplyVoucher(payload)),
  getHistoryShipping: () => dispatch(getHistoryShipping()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalVoucherCode);
